import React from 'react';

export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <section className="max-w-[1200px] mx-auto px-6 pt-16 md:pt-24 pb-8">
      {eyebrow && (
        <p className="font-mono text-xs md:text-sm uppercase tracking-widest text-[#273C46] mb-6 animate-fade-in-up">
          {eyebrow}
        </p>
      )}
      <h1
        data-testid="page-title"
        className="text-[40px] md:text-[64px] lg:text-[80px] leading-[1.02] text-[#0D212C] tracking-tight animate-fade-in-up"
        style={{ animationDelay: '0.08s' }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          className="mt-6 max-w-2xl text-base md:text-lg text-[#273C46] leading-relaxed animate-fade-in-up"
          style={{ animationDelay: '0.16s' }}
        >
          {subtitle}
        </p>
      )}
      {children && (
        <div className="mt-8 animate-fade-in-up" style={{ animationDelay: '0.24s' }}>
          {children}
        </div>
      )}
    </section>
  );
}

export function Section({ children, className = '' }) {
  return (
    <section className={`max-w-[1200px] mx-auto px-6 py-10 md:py-16 ${className}`}>
      {children}
    </section>
  );
}

export function StatRow({ items }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 border-y border-[#051A24]/10 py-8">
      {items.map((s, i) => (
        <div key={i}>
          <div className="text-[28px] md:text-[36px] font-serif text-[#0D212C] leading-none">{s.value}</div>
          <div className="mt-2 text-xs md:text-sm text-[#273C46]">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
